export const FEATURE_FLAGS_CONFIG = {
  newClaimsFlow: {
    label: 'New claims flow',
    description:
      'Open new claims with authorization, reason codes, charges, holds and approvals. Claims already open keep the flow they started with.',
  },
};
